module.exports = __webpack_public_path__ + "img/1880.1c211a1.webp";